/* Rotating button copy is a waiting animation, not measured processing stages. */
(function(){
 'use strict';
 const labels=['Understanding','Matching','Choosing NVR','Sizing storage','Building','Pricing'];
 const paint=()=>new Promise(resolve=>{let done=false;const finish=()=>{if(done)return;done=true;clearTimeout(timer);resolve();},timer=setTimeout(finish,50);requestAnimationFrame(()=>requestAnimationFrame(finish));});
 function create(anchor){
  const scope=anchor.closest('form')||anchor,buttons=[...scope.querySelectorAll('button[type=submit]')],original=new Map();
  const live=document.createElement('span');live.className='visually-hidden';live.setAttribute('role','status');anchor.closest('[data-requirements-planner]').after(live);
  let state='idle',timer=null,index=0;
  const label=()=>labels[index]+'\u2026';
  const tick=()=>{for(const button of buttons)button.textContent=label();};
  const stop=()=>{clearInterval(timer);timer=null;for(const button of buttons){if(original.has(button))button.textContent=original.get(button);button.removeAttribute('data-ai-waiting');button.removeAttribute('aria-busy');}original.clear();};
  return {
   get running(){return state==='running';},
   get label(){return state==='running'?label():'';},
   start(){stop();state='running';index=0;for(const button of buttons){original.set(button,button.textContent);button.dataset.aiWaiting='';button.setAttribute('aria-busy','true');}tick();live.textContent='Preparing your recommendation. Please wait.';timer=setInterval(()=>{index=(index+1)%labels.length;tick();},1000);},
   done(){},
   note(){},
   async run(indices,work){await paint();return await work();},
   pause(message){stop();state='paused';live.textContent=message;},
   fail(){stop();state='failed';live.textContent='Your choices are kept. Please try again.';},
   finish(message='Your recommendation has been updated.'){stop();state='idle';live.textContent=message;}
  };
 }
 window.SMKAdvisorProgress={create};
})();
